import { css, cx } from "@emotion/css";
import { ListItemButton } from "@mui/material";
import type React from "react";
interface ListItemButtonProps {
    className?: string;
    children: React.ReactNode;
    onClick: () => void;
}
/**
 * @deprecated Do not use this component. This exists specifically to support the process sidebar items in Portal.
 * The styling of the process sidebar is very tightly coupled to its markup which includes this component's implementation.
 */
export function LegacyListItemButton({ className, children, onClick }: ListItemButtonProps) {
    return (<ListItemButton disableRipple disableTouchRipple component="a" className={cx(styles.listItem, className)} disableGutters={true} onClick={onClick}>
            {children}
        </ListItemButton>);
}
const styles = {
    listItem: css({
        "&.MuiListItem-root": {
            padding: 0,
        },
    }),
};
